enum EmploymentRoleType {
  ADMIN = 'ADMIN',
  COWORKER = 'COWORKER',
}

export default EmploymentRoleType;
